module.exports = __webpack_public_path__ + "static/media/search-icon.2cd04639.svg";